// extracted by mini-css-extract-plugin
module.exports = {"skipToMainContentLink":"styles_skipToMainContentLink___OzyE"};